import { CreatableSelectInput } from 'ui-library';
import './styles/selectStyles.scss';

export const CreatableSelect = ({ label, options, name, ...props }) => {
  return (
    <div className="hc-mb-md">
      <label className="customLabel" htmlFor={name} id={`${name}Label`}>
        {label}
      </label>
      <CreatableSelectInput
        options={options}
        name={name}
        aria-labelledby={`${name}Label`}
        classNamePrefix="customSelect"
        {...props}
      />
    </div>
  );
};
